import axios from "axios";
import { reactLocalStorage } from "reactjs-localstorage";

let headers = {};

const origin = window.location.origin;

console.log(origin, "|||ORIGIN");

let BACKEND_URL = "https://api.platinumclubnet.com/api/";

if (
  origin == "https://member.privateclubworld.com" ||
  origin == "https://member.platinumclubnet.com"
) {
  BACKEND_URL = "https://api.platinumclubnet.com/api/";
} else if (
  origin == "https://pcn1.aventusinformatics.com" ||
  origin == "https://pcw1.aventusinformatics.com"
) {
  BACKEND_URL = "https://mob-api.aventusinformatics.com/api/";
} else if (
  origin == "https://demo-member.platinumclubnet.com" ||
  origin == "https://demo-member.privateclubworld.com"
) {
  BACKEND_URL = "https://demo-api.platinumclubnet.com/api/";
} else if (
  origin == "https://uat-member.privateclubworld.com/" ||
  origin == "https://uat-member.platinumclubnet.com/"
) {
  BACKEND_URL = "https://uat-api.platinumclubnet.com/api/";
} else {
  BACKEND_URL = "https://demo-api.platinumclubnet.com/api/";
}



const axiosInstance = axios.create({
  baseURL: BACKEND_URL,
  headers,
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = reactLocalStorage.get("token");
    const timezones = localStorage.getItem("time_zone")
      ? localStorage.getItem("time_zone")
      : "";
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    let params = {};
    params.cms = false;
    const currentTheme = document.documentElement.getAttribute("theme");
    if (currentTheme == "platinum-club-net") {
      params.pcn = true;
    } else {
      params.pcn = false;
    }
    if (timezones) {
      params.timezone = timezones;
    }
    config.params = {
      ...config.params,
      ...params,
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) =>
    new Promise((resolve, reject) => {
      resolve(response);
    }),
  (error) => {
    if (!error.response) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }

    if (error.response.status === 403) {
    } else if (error.response.status === 401) {
      localStorage.clear();
      if (window.location.pathname != "/login") {
        window.location = "/login";
      }
    } else {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
  }
);

export default axiosInstance;
